import type { ReturningReport } from '../../../common/hooks/use-shopper-insights-api.hook';

/**
 * Below this many devices in either group, a comparison between the nudged and
 * the held-out shoppers is noise: one cart click swings the rate by double
 * digits. The card says "too early" instead of printing a lift.
 */
export const MIN_DEVICES_TO_COMPARE = 30;

/** Whether the card has anything to show for the period. */
export const hasReturningActivity = (report: ReturningReport | null | undefined): boolean =>
    !!report && (report.nudges.shown > 0 || report.nudges.heldOut > 0 || report.topProducts.length > 0);

/**
 * The difference the nudge made to the cart rate, in percentage points —
 * nudged minus held out — or null while either group is too small to say.
 */
export const returningLift = (report: ReturningReport | null | undefined): number | null => {
    if (!report) return null;
    const { nudged, holdout } = report;
    if (nudged.devices < MIN_DEVICES_TO_COMPARE || holdout.devices < MIN_DEVICES_TO_COMPARE) return null;
    if (nudged.cartRate === null || holdout.cartRate === null) return null;
    return Math.round((nudged.cartRate - holdout.cartRate) * 1000) / 10;
};

/** "+4.2 pts" / "−1.5 pts" / "±0 pts". */
export const formatLift = (points: number): string =>
    `${points > 0 ? '+' : points < 0 ? '−' : '±'}${Math.abs(points).toLocaleString(undefined, { maximumFractionDigits: 1 })} pts`;
